import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/system';

import { TEXT_SECONDARY } from '../tokens';

/**
 * The entity's facts for the namespace on show.
 */
export default function HeroFacts({ facts, loading }) {
  return (
    <Box sx={{
      fontSize: '.9rem',
      color: TEXT_SECONDARY,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }}>
      {loading || !facts.length ? '\u00A0' : facts.map((fact, i) => (
        <React.Fragment key={fact.text}>
          {i > 0 && ' \u00B7 '}
          <span title={fact.title}>{fact.text}</span>
        </React.Fragment>
      ))}
    </Box>
  );
}

HeroFacts.propTypes = {
  facts: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    title: PropTypes.string,
  })),
  loading: PropTypes.bool,
};

HeroFacts.defaultProps = {
  facts: [],
  loading: false,
};
